<template>
    <rkm-form ref="Form">

        <rkm-area type="fieldset" title="Medicamentos">

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="data.medicamentoSupervisor.dispensar"
                    >
                        Dispensar medicamentos, antes da próxima data de retirada, somente com a utilização
                        da senha do supervisor.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="Posologia">

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="data.posologia.isObrigatorio"
                    >
                        A posologia é obrigatória. O campo "prescrito" será automaticamente preenchido com base nas
                        informações da posologia, sendo impossível modificá-lo. O campo "entregue" estará disponível somente
                        após o preenchimento das informações da posologia.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.prazoReceitaDias"
                    label="Prazo de dias da receita"
                    number
                    v-model="data.dispensacao.prazoReceitaDias"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :label="false"
                    v-model="data.dispensacao.utilizaSolicitacaoMedicamentosAmbulatorio"
                >
                    Utiliza a solicitação de medicamentos da funcionalidade Ambulatório &rarr; Atendimento.
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-area type="fieldset" title="Limite de Prescrição">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        v-model="data.limitePrescricaoMedicamento.limiteDias"

                        :validations="validations.limiteDias"
                        label="Limite em dias aceito para a validade da receita. Se não informado, o padrão preenchido são de 180 dias."
                        number
                />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="cliente && cliente.ativoAppConectasusCidadao"
            type="fieldset"
            title="Integrações de Aplicativos"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="data.appCidadao.permiteTratamentoMedicamentoso"
                    >
                        Permitir acompanhamento do tratamento medicamentoso no aplicativo ConectaSUS - Cidadão, da Farmácia.
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor"
                            small
                            
                             v-rkm-popover.hover.left="{
                                html: true,
                                content: 'Quando ativado, o cidadão acompanha pelo APP Cidadão o tratamento medicamentoso a partir das dispensações registradas em seu nome. Quando desativado, a opção de acompanhamento do tratamento não é exibida ao cidadão no aplicativo.'
                            }"
                        />
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="Alto custo">
            <rkm-area type="fieldset" title="Informações obrigatórias">
                <template v-slot:trailing>
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Marque o que o processo de alto custo precisa ter para ser salvo. Exemplo: com CID marcado, o sistema não salva o processo sem o CID. A regra vale para processo novo e também para processo antigo quando ele for editado.'
                        }"
                    />
                </template>

                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-checkbox v-model="data.altoCusto.cidObrigatorio">
                            CID
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-form-checkbox v-model="data.altoCusto.pesoAlturaObrigatorio">
                            Peso e Altura
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox v-model="data.altoCusto.protocoloAutomatico">
                        Protocolo automático
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor"
                            small
                            v-rkm-popover.hover.left="{
                                html: true,
                                content: 'Marcado: o sistema gera o protocolo ao salvar um processo novo, no formato número/ano (exemplo: 1/2026), em uma única sequência para todos os setores do município. A contagem começa em 1 ao marcar a opção e recomeça em 1 a cada ano. Processos já cadastrados não recebem protocolo. Desmarcado: o protocolo é digitado pelo usuário e não é obrigatório.'
                            }"
                        />
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({cliente: 'getCliente'}),

        validations() {

            return {
                prazoReceitaDias: { max: 3 },
                limiteDias: { max: 3, max_value: 730 },
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        }
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>
<style>

.infor {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
    vertical-align: middle;               
    margin-left: 4px;                
    }            
</style>